import { SelectProps } from "antd";
import { formatJobFunctions } from "../../helper";
import { restoreData, getOneLabel, restoreOriginalObject } from "./helper";
import MultiSelect from "../../baseSelect/pc/MultiSelect";

import { MultiSelectPcPropsType } from "../../baseSelect/pc/MultiSelect/type";

type valueType = {
  mainFunctions: string[];
  jobFunctions: string[];
  functionTitles: string[];
};

type PropsType = {
  label: string;
  main_function_filter: any[];
  value: valueType;
  searchBoardPlaceholder?: string;
  boardClearText?: string;
  boardApplyFiltersText?: string;
  realTimeRefresh?: boolean;
} & SelectProps &
  Pick<MultiSelectPcPropsType, "wrapperClassName" | "visibleSearch">;

const JobFunctionSelectPc = ({
  main_function_filter = [],
  value,
  onChange,
  ...rest
}: PropsType) => {
  const options = formatJobFunctions(main_function_filter);
  const newValue = restoreData(value, options);

  const generateChangeValue = (value) => {
    const changeValue = restoreOriginalObject(value);
    onChange(changeValue, options);
  };

  const oneLabel = getOneLabel(
    options,
    value.mainFunctions?.[0] || value.jobFunctions?.[0] || value.functionTitles?.[0]
  );

  return (
    <MultiSelect
      options={options}
      value={newValue}
      onChange={generateChangeValue}
      oneLabel={oneLabel}
      cascaderPanelProps={{
        showCheckedStrategy: "Cascader.SHOW_PARENT"
      }}
      {...rest}
    />
  );
};

export default JobFunctionSelectPc;
